import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    expirationTooltip: (days: number) => string | React.ReactNode;
    daysUntilExpiration: (days: number) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            expirationTooltip: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (days: number) => __intl__.intl().formatMessage({ id: "AssetLifecycleExpirationLabel.expirationTooltip?c=2t4t29imvybe8", defaultMessage: "{days, plural, one {This asset will delete in {days} day} other {This asset will delete in {days} days}}" }, { days: days }));
                },
                enumerable: true,
                configurable: true
            },
            daysUntilExpiration: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (days: number) => __intl__.intl().formatMessage({ id: "AssetLifecycleExpirationLabel.daysUntilExpiration?c=2ogzdf3vrfic8", defaultMessage: "{days}d" }, { days: days }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
